export { default as Root } from "./Root";
export { default as Home } from "./Home";
export { default as News } from "./News";
export { default as Events } from "./Events";
export { default as Promotion } from "./Promotion";
export { default as PromotionDetail } from "./PromotionDetail";
export { default as NewsDetail } from "./NewsDetail";
export { default as EventDetail } from "./EventDetail";
export { default as Career } from "./Career";
export { default as About } from "./About";
export { default as Ourshow } from "./Ourshow";
export { default as Contact } from "./Contact";
export { default as HighlightDetail } from "./HighlightDetail";
export { default as Booking } from "./Booking";
export { default as Agent } from "./Agent";
export { default as AgentLoginFirstTime } from "./AgentLoginFirstTime";
export { default as Pdpa } from "./Pdpa";



// WEBPACK FOOTER //
// ./src/pages/index.js